import { Text } from '@bpba/ui-components';
import { ReactNode } from 'react';
import styled from 'styled-components';

export const SubTitulo = ({ children }: { children: ReactNode }) => {
  return (
    <StyledText tabIndex={-1} fontWeight={500} fontSize={'16px !important'} mb={'24px !important'} color={'primary.0'}>
      {children}
    </StyledText>
  );
};

const StyledText = styled(Text)({
  outline: 'none',
});
